import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material';

import { IBaseListView } from '../../../../icemedx-lib/src/components/baseview.component';
import { IIceEntity } from 'projects/icemedx-lib/src/models/core/IceEntity';
import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';

import {
  IcecontrolSettings,
  IcemattableSettings,
  iceColumnDefinition,
  IcepanelgroupSettings,
  IcepanelsectionSettings,
  IcepanelSettings,
  IcepanelcontainerRowSettings,
  IcepanelcontainerSettings,

  SECTION_CONTROL_ALIGNMENT,
} from '../../../../icemedx-lib/src/components/models/icesettings';

import { AppService } from '../app.service';
import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { userTypes } from '../../../../icemedx-lib/src/login/login.config';
import { LoginService } from '../../../../icemedx-lib/src/login/login.service';
import { DomainService } from 'projects/icemedx-lib/src/services/domain/domain.service';
import { IceTypes } from 'projects/icemedx-lib/src/models/icetypes';
import { PatientService } from 'projects/icemedx-lib/src/services/patient/patient.service';
import { managementguideline } from 'projects/icemedx-lib/src/models/ehr/subs/managementguideline';
import { managementguidelineindex } from 'projects/icemedx-lib/src/models/ehr/subs/managementguidelineindex';
import { observation } from 'projects/icemedx-lib/src/models/ehr/subs/observation';
import { MedicalcodesService } from 'projects/icemedx-lib/src/services/medicalcodes/medicalcodes.service';
import { diagnosis } from 'projects/icemedx-lib/src/models/ehr/diagnosis';
import { diagnosisreference } from 'projects/icemedx-lib/src/models/ehr/subs/diagnosisreference';
import { subtypereference } from 'projects/icemedx-lib/src/models/ehr/subs/subtypereference';

const CancelReport: string = "CancelReport";
const SaveReport: string = "SaveReport";
const ResolvedCondition: string = "resolution_date";
const StatusofCondition: string = "status_type";
const ApplyOutcome: string = "diagnosis_type_code";
const OnsetOfOutcome: string = "onset_of_illness_date";
const ResolvedOutcome: string = "resolution_date";
const StatusofOutcome: string = "status_type";
const NewOnsetOfOutcome: string = "onset_of_illness_date";
const NewTitleOfOutcome: string = "title";

@Component({
  selector: 'app-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.scss'],
  providers: [AppService, IceNavService]
})
export class SurveyComponent implements OnInit, IBaseListView {
  // Data Member 
  ptName: string = "";
  glTitle: string = "";
  glDescription: string = "";
  glRule: managementguideline = null;
  conditionToResolvePanel: IcepanelSettings = null;
  conditionDataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  outcomeDataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  newoutcomeDataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  diags: diagnosis[] = [];
  pregnancycodes: string[] = ["z34", "z35", "o30"];
  pregnancyoutcomecodes: string[] = ["z37", "p95", "o80", "o82", "o00", "o02", "o03", "o04", "o05", "o06", "o07", "o70", "o60", "o63", "o69", "o70", "o75", "o81", "p03.8", "o94", "p01.6", "o36.4", "o95", "o31.2", "o96", "o96.0", "o96.1", "o96.9", "o97", "o97.0", "o97.1", "o97.9"];

  // Settings Member
  surveySettings: IcepanelcontainerSettings = null;
  conditionTableSettings: IcemattableSettings = null;
  resolvedConditionCtrl: IcecontrolSettings = null;
  statusofConditionCtrl: IcecontrolSettings = null;

  applyOutcomeCtrl: IcecontrolSettings = null;
  outcomeTableSettings: IcemattableSettings = null;
  onsetOfOutcomeCtrl: IcecontrolSettings = null;
  resolvedOutcomeCtrl: IcecontrolSettings = null;
  statusOfOutcomeCtrl: IcecontrolSettings = null;

  newOutomeSection: IcepanelsectionSettings = null;
  newoutcomeTableSettings: IcemattableSettings = null;
  newTitleOfOutcomeCtrl: IcecontrolSettings = null;
  newOnsetOfOutcomeCtrl: IcecontrolSettings = null;

  
  private patientReadySub: Subscription = this.appSvc.onPatientReady(this.appSvc.getCurrentAccountType() == IceTypes.ACCOUNT_TYPE.actPatient ? this.appSvc.getCurrentAccount() : this.appSvc.getCurrentPatient()).subscribe(
    pt => {
      if (pt) this.ptName = this.appSvc.getPatientName(pt) + " Chart No. #" + pt.trans_account;     
    },
    error => {
    });

  constructor(private appSvc: AppService,
    private navSvc: IceNavService,
    private ptSvc: PatientService,
    private codeSvc: MedicalcodesService,
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef) {

    let curAct = appSvc.getCurrentAccount();
    let curPtAct = appSvc.getCurrentPatient();
    let curActType = appSvc.getCurrentAccountType();
    appSvc.refreshAccountCache(curAct, curActType);
    appSvc.refreshPatientCache(curPtAct, curAct);

    navSvc.setNavOn(false);

    this.activatedRoute.params.subscribe(next => {
      if (next == null || next.key == "0" || next.length == 0) {
        // view error
      }
      else {
        // To do: When this feature is released to patient then we will have to get provider domain

        if (Iceutility.toLong(next.srctype) == IceTypes.SourceType.srcUndefined) {
          this.codeSvc.getCodes("MANAGEMENT_GUIDELINE", next.glkey, "", "", appSvc.getCurrentAccount(), appSvc.getCurrentAccountType()).subscribe(
            data => {
              this.surveySettings = this.viewSetup(data != null && data.length > 0 ? data : null);
            },
            error => {
            });
        }
        else {
          ptSvc.getAlerts(appSvc.getCurrentAccountType() == IceTypes.ACCOUNT_TYPE.actPatient ? appSvc.getCurrentAccount() : appSvc.getCurrentPatient(), appSvc.getCurrentAccount(), appSvc.getCurrentAccountType(), "", "", "", 0, "", "", "", next.glkey).subscribe(
            data => {
              this.surveySettings = this.viewSetup(data != null && data.length > 0 ? data : null);
            },
            error => {
            });
        }
      }
    });

  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.patientReadySub.unsubscribe();
  }

  private showEPDSSections(): IcepanelsectionSettings[] {
    let surveySections: IcepanelsectionSettings[] = [];
    try {

      for (let iob = 0; iob < this.glRule.OBSERVS.length; iob++) {
        let ob: observation = this.glRule.OBSERVS[iob];

        let answers = ob.SUBTYPES.map(s => { return { name: s.auto_transcription, value: s.type_lower_limit } });

        let controls: IcecontrolSettings[] = [
          new IcecontrolSettings("icelabel", { value: iob + 1 + "). " + ob.description, width: "75px" }, null, null),
          new IcecontrolSettings("iceselect", { menuItems: answers, width: "250px" }, null, null, ob.obx4_observation_subid, "Answer")
            .setControlName(ob.obx4_observation_subid)
            .createFormControl(ob.obx5_observation_value, [Validators.required])
        ];

        let questionSection = new IcepanelsectionSettings("SurveySection", { class: ["yalla"], styles: { width: "100%" } }, [], controls, null)
          .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical);
        surveySections.push(questionSection);
      }
    }
    catch (e) {
      console.log(e);
    }
    return surveySections;
  }

  private createsubtype(title: string, val: string, subtype: number): subtypereference {
    let ret: subtypereference = null;
    try {
      ret = new subtypereference();
      ret.sub_type_reference_key = Iceutility.guid(true);
      ret.auto_transcription = title;
      ret.type_lower_limit = val;
      ret.sub_type = subtype;
    }
    catch (e) {
      console.log(e);
    }
    return ret;
  }

  private showDXOBOUTCOMESections(): IcepanelsectionSettings[] {
    let surveySections: IcepanelsectionSettings[] = [];
    try {

      for (let iob = 0; iob < this.glRule.OBSERVS.length; iob++) {
        let ob: observation = this.glRule.OBSERVS[iob];

        debugger;
        if (Iceutility.isdefined(ob.SUBTYPES) && ob.SUBTYPES.length > 0
          && ("DXOB-OUTCOME05" == ob.obx4_observation_subid
          || "DXOB-OUTCOME07" == ob.obx4_observation_subid
          || "DXOB-OUTCOME09" == ob.obx4_observation_subid)) {
          let newans = ob.SUBTYPES.filter(a => a.type_lower_limit == '3');
          if (newans.length == 0) {
            ob.SUBTYPES.push(this.createsubtype("Unknown", "3", Iceutility.toLong(ob.obx3_observation_id_file_name)));
            ob.SUBTYPES.push(this.createsubtype("Male (Stillbirth)", "4", Iceutility.toLong(ob.obx3_observation_id_file_name)));
            ob.SUBTYPES.push(this.createsubtype("Female (Stillbirth)", "5", Iceutility.toLong(ob.obx3_observation_id_file_name)));
            ob.SUBTYPES.push(this.createsubtype("Unknown (Stillbirth)", "6", Iceutility.toLong(ob.obx3_observation_id_file_name)));
          }
        }

        let answers = ob.SUBTYPES.map(s => { return { name: s.auto_transcription, value: s.type_lower_limit } });

        let answer = ob.obx5_observation_value;
        if (answer == null
          || answer.length == 0
          && ("DXOB-OUTCOME07" == ob.obx4_observation_subid
          || "DXOB-OUTCOME08" == ob.obx4_observation_subid
          || "DXOB-OUTCOME09" == ob.obx4_observation_subid
          || "DXOB-OUTCOME10" == ob.obx4_observation_subid)){
          answer = "0";
        }

        let controls: IcecontrolSettings[] = [
          new IcecontrolSettings("icelabel", { value: iob + 1 + "). " + ob.description, width: "75px" }, null, null),
          new IcecontrolSettings("iceselect", { menuItems: answers, width: "250px" }, null, null, ob.obx4_observation_subid, "Answer")
            .setControlName(ob.obx4_observation_subid)
            .createFormControl(answer, [Validators.required])
        ];

        let questionSection = new IcepanelsectionSettings("SurveySection", { class: ["yalla"], styles: { width: "100%" } }, [], controls, null)
          .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical);
        surveySections.push(questionSection);
      }

    }
    catch (e) {
      console.log(e);
    }
    return surveySections;
  }

  viewSetup(dat: IIceEntity[]): IcepanelcontainerSettings {
    let setup: IcepanelcontainerSettings = null;
    try {
      if (dat == null) {
        return null;
      }
      this.glRule = <managementguideline>dat[0];
      this.glTitle = this.glRule.title;
      this.glDescription = this.glRule.description;

      //////////////////////
      // Show Survey

      let surveysections: IcepanelsectionSettings[] = [];
      if (this.glRule.obr11_specimen_action_code == "EPDS") {
        this.glDescription += " As you are pregnant or have recently had a baby, we would like to know how you are feeling.  Please check the answer that comes closest to how you have felt IN THE PAST 7 DAYS, not just how you feel today. ";
        let sections = this.showEPDSSections();
        surveysections = surveysections.concat(sections);
      }
      else if (this.glRule.obr11_specimen_action_code == "DXOB-OUTCOME") {
        //////////////////////
        /// Conditions
        this.resolvedConditionCtrl = new IcecontrolSettings("icelabel", { linkMode: "labeldatepicker", placeholder: "Date resolved", width: "100px" }, null, null, ResolvedCondition)
          .setControlName(ResolvedCondition)
          .createFormControl('', [Validators.required]);

        this.statusofConditionCtrl = new IcecontrolSettings("icelabel", { linkMode: "labelselect", menuItems: PatientService.getProblemStatuses(), width: "100px" }, null, null, StatusofCondition, "Status of Condition")
          .setControlName(StatusofCondition)
          .createFormControl(0, [Validators.required]);

        this.conditionTableSettings = new IcemattableSettings(
          "ConditionTable",
          [
            new iceColumnDefinition("title", "CONDITION TO RESOLVE", false, false,
              new IcecontrolSettings("icelabel", {}, null, null)),
            new iceColumnDefinition("icd_code", "ICD", false, false),
            new iceColumnDefinition("onset_of_illness_date", "Onset of Condition", false, false),
            new iceColumnDefinition("weeks", "Weeks", false, false),
            new iceColumnDefinition("resolution_date", "Date resolved", false, false,
              this.resolvedConditionCtrl),
            new iceColumnDefinition("status_type", "Status", false, false,
              this.statusofConditionCtrl),
            new iceColumnDefinition("diagnosis_key", "diagnosis_key", true),
          ],
          this.conditionDataSource,
          [],
          false,
          null,
          true
        );

        let conditionTables: IcemattableSettings[] = [
          this.conditionTableSettings
        ];

        //////////////////////
        /// Resolutions
        this.applyOutcomeCtrl = new IcecontrolSettings("icecheckbox", { width: "50px", cursor: 'pointer' }, null, null, null)
          .setControlName(ApplyOutcome);

        this.onsetOfOutcomeCtrl = new IcecontrolSettings("icelabel", { linkMode: "labeldatepicker", placeholder: "Start Date", width: "100px" }, null, null, OnsetOfOutcome)
          .setControlName(OnsetOfOutcome)
          .createFormControl('', [Validators.required]);

        this.resolvedOutcomeCtrl = new IcecontrolSettings("icelabel", { linkMode: "labeldatepicker", placeholder: "End Date", width: "100px" }, null, null, ResolvedOutcome)
          .setControlName(ResolvedOutcome)
          .createFormControl('', [Validators.required]);

        this.statusOfOutcomeCtrl = new IcecontrolSettings("icelabel", { linkMode: "labelselect", menuItems: PatientService.getProblemStatuses(), width: "100px" }, null, null, StatusofOutcome, "Status of Condition")
          .setControlName(StatusofOutcome)
          .createFormControl(0, [Validators.required]);

        this.outcomeTableSettings = new IcemattableSettings(
          "OutcomeTable",
          [
            new iceColumnDefinition("diagnosis_type_code", "Apply", false, false,
              this.applyOutcomeCtrl),
            new iceColumnDefinition("title", "OUTCOME OR RESOLUTION", false, false,
              new IcecontrolSettings("icelabel", {}, null, null)),
            new iceColumnDefinition("icd_code", "ICD", false, false),
            new iceColumnDefinition("onset_of_illness_date", "Start date", false, false,
              this.onsetOfOutcomeCtrl),
            new iceColumnDefinition("resolution_date", "End date", false, false,
              this.resolvedOutcomeCtrl),
            new iceColumnDefinition("status_type", "Status", false, false,
              this.statusOfOutcomeCtrl),
            new iceColumnDefinition("diagnosis_key", "diagnosis_key", true),
          ],
          this.outcomeDataSource,
          [],
          false,
          null,
          true
        ).showAddButton(true);

        let outcomeTables: IcemattableSettings[] = [
          this.outcomeTableSettings
        ];

        /////////////////////////
        // New Outcome
        this.newTitleOfOutcomeCtrl = new IcecontrolSettings("iceselect", { menuItems: MedicalcodesService.getPregnancyOutcomeList(), width: "550px" }, null, null, NewTitleOfOutcome, "New Outcome")
          .setControlName(NewTitleOfOutcome)
          .createFormControl(0, [Validators.required]);

        let curDate = Iceutility.getDateTextEx(Iceutility.GetLocalDate());
        this.newOnsetOfOutcomeCtrl = new IcecontrolSettings("icedatepicker", { placeholder: "Start Date", value: curDate, width: "100px" }, null, null, NewOnsetOfOutcome)
          .setControlName(NewOnsetOfOutcome)
          .createFormControl(curDate, [Validators.required]);

        this.newOutomeSection = new IcepanelsectionSettings(
          "NewOutcomeSection", { class: [], styles: { width: "100%" } }, [], [
            this.newTitleOfOutcomeCtrl,
            this.newOnsetOfOutcomeCtrl,
            new IcecontrolSettings("icepanelbutton", { text: "CONTINUE AND ADD NEW OUTCOME", class: [], glyphClass: "fa-plus" }, null, null, "AddNewContinue"),
            new IcecontrolSettings("icepanelbutton", { text: "CANCEL", class: [], glyphClass: "fa-times" }, null, null, "AddNewCancel")
          ], null).setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical).setShow(false);

        let conditionGroups: IcepanelgroupSettings[] = [
          new IcepanelgroupSettings(null, conditionTables),
          new IcepanelgroupSettings(null, outcomeTables),
        ];

        surveysections.push(new IcepanelsectionSettings(
          "ConditionSection", { class: [], styles: { width: "100%" } }, conditionGroups, [], null));
        
        surveysections.push(this.newOutomeSection);

        let sections = this.showDXOBOUTCOMESections();
        surveysections = surveysections.concat(sections);
      }
      else {
        this.ptSvc.logMessage(IceTypes.LOGTYPE.ltUserAlert, " Survey type is not supported.");
      }

      let headerControls = [
        new IcecontrolSettings("icesubmitbutton", { class: "fas fa-check", width: "50px" }, null, null, SaveReport),
        new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px" }, null, null, CancelReport)
      ];

      this.conditionToResolvePanel = new IcepanelSettings("SurveyView", this.glRule.management_guideline_key, this.glRule.activity_description, "", surveysections, headerControls)
        .enableForm();

      let panels: IcepanelSettings[] = [
        this.conditionToResolvePanel
      ];

      let panelrows: IcepanelcontainerRowSettings[] = [new IcepanelcontainerRowSettings(panels)];
      setup = new IcepanelcontainerSettings("SurveyViewContainer", panelrows);

      if (this.glRule.obr11_specimen_action_code == "DXOB-OUTCOME") {
        this.ptSvc.getProblems(this.appSvc.getCurrentAccountType() == IceTypes.ACCOUNT_TYPE.actPatient ? this.appSvc.getCurrentAccount() : this.appSvc.getCurrentPatient()).subscribe(
          data => {
            if (data != null && data.length > 0) {
              this.diags = data;

              
              this.conditionDataSource.data = this.generatePregDiags(this.diags, this.pregnancycodes);
              this.outcomeDataSource.data = this.generatePregDiags(this.diags, this.pregnancyoutcomecodes); 
            }
          },
          error => {
          });
      }
    }
    catch (e) {
      console.log(e);
    }
    return setup;
  }

  private generatePregDiags(data: any[], codes): any[] {
    if (data == null || data.length == 0) return [];
    if (codes == null || codes.length == 0) return [];

    let diags: diagnosis[] = data;
    let obdiags = diags.filter(d => codes.filter(c => d.icd_code.toLowerCase().indexOf(c) >= 0).length > 0);

    let conditions = [];
    for (let idx = 0; idx < obdiags.length; idx++) {
      let dx: diagnosis = obdiags[idx];

      let termText = "";
      let weeks = Iceutility.convertDatesToWeeks(Iceutility.GetLocalDate(dx.onset_of_illness_date), Iceutility.GetLocalDate(dx.resolution_date));
      let parts = weeks.toFixed(2).toString().split(".");
      if (parts.length > 0) {
        termText = parts[0];
      }

      if (parts.length > 1) {
        termText += " and " + Iceutility.toLong((Iceutility.toLong(parts[1]) / 100) * 7).toString() + " days";
      }

      let stat = PatientService.getProblemStatus(dx.status_type);
      let resdt = Iceutility.getDateTextEx(dx.resolution_date, null, false);
      if (resdt == "") resdt = "...";

      let dxRefs = this.glRule.DIAGS.filter(dref => dref.diagnosis_key == dx.diagnosis_key );
      conditions.push({
        diagnosis_type_code: dxRefs.length > 0 ? (dxRefs[0].diagnosis_type_code != null && dxRefs[0].diagnosis_type_code.length > 0) : false,
        icd_code: dx.icd_code,
        title: dx.title,
        onset_of_illness_date: Iceutility.getDateTextEx(dx.onset_of_illness_date, null, false),
        resolution_date: resdt,
        weeks: termText,
        status_type: stat,
        diagnosis_key: dx.diagnosis_key
      });
    }
    return conditions;
  }

  public onAddRowButtonClick(event) {
    try {
      this.cdr.markForCheck();
      let form: FormGroup = this.conditionToResolvePanel.getForm();
      if (form != null) {
        form.get(NewOnsetOfOutcome).setValue(Iceutility.GetLocalDate());
      }

      this.newOutomeSection.setShow(true);
      this.cdr.detectChanges();
    }
    catch (e) {
      console.log(e);
    }
  }

  private addDiagRef(diag: diagnosis) {
    if (diag == null) return {};
    try {
      let diagref: diagnosisreference = new diagnosisreference();
      diagref.diagnosis_reference_key = Iceutility.guid(true);
      diagref.diagnosis_key = diag.diagnosis_key;
      diagref.title = diag.title;
      diagref.icd_code = diag.icd_code;
      diagref.diagnosis_type_code = "ABF";
      diagref.synonym = true;
      diagref.onset_of_illness_date = diag.onset_of_illness_date;
      diagref.resolution_date = diag.resolution_date;
      diagref.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
      if (Iceutility.isdefined(this.glRule.DIAGS) == false || this.glRule.DIAGS.length == 0)
        this.glRule.DIAGS = [];

      this.glRule.DIAGS.push(diagref);
      return diagref;
    }
    catch (e) {
      console.log(e);
    }
    return {};
  }

  public onButtonClick(event) {
    try {
      if (event.buttonSettings && event.buttonSettings.id == "AddNewContinue") {
        let newDx: diagnosis = new diagnosis();
        newDx.diagnosis_key = Iceutility.guid(true);
        let form: FormGroup = this.conditionToResolvePanel.getForm();
        let code = form.get(NewTitleOfOutcome).value;
        let onset = form.get(NewOnsetOfOutcome).value;

        let outcomeCodes = MedicalcodesService.getPregnancyOutcomeList().filter(c => c.value == code);
        if (outcomeCodes.length > 0) newDx.title = outcomeCodes[0].name;

        newDx.icd_code = code;
        newDx.trans_account = this.appSvc.getCurrentPatient();
        newDx.onset_of_illness_date = Iceutility.convertToUTCEx(onset);
        newDx.resolution_date = newDx.onset_of_illness_date;
        newDx.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;

        var outcomes = this.outcomeDataSource.data;
        this.cdr.markForCheck();

        var cdr = this.cdr;
        var diags = this.diags;
        var rule: managementguideline = this.glRule;
        this.ptSvc.insertUpdateDiagnsosis(this.appSvc.getCurrentPatient(), this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), newDx).subscribe(
          data => {

            if (Iceutility.isdefined(diags) == false || diags.length == 0)
              diags = [];

            newDx.offline_record_status = IceTypes.offlineRecStatus.offlineNoChange;
            diags.push(newDx);
            let newdiags = this.generatePregDiags([this.addDiagRef(newDx)], this.pregnancyoutcomecodes);
            this.outcomeDataSource.data = outcomes.concat(newdiags);

            setTimeout(function () {
              cdr.detectChanges();
            }, 200);
            this.ptSvc.logMessage(IceTypes.LOGTYPE.ltUserAlert, "Successfully saved: " + newDx.title);
          },
          error => {

          }
        )
      }
      else if (event.buttonSettings && event.buttonSettings.id == "AddNewCancel") {
        let form: FormGroup = this.conditionToResolvePanel.getForm();
        if (form != null) {
          // reset to a valid state and mark clean
          form.get(NewOnsetOfOutcome).setValue(Iceutility.GetLocalDate());
          form.get(NewOnsetOfOutcome).markAsPristine();
          form.get(NewOnsetOfOutcome).markAsUntouched();
          form.get(NewTitleOfOutcome).markAsPristine();
          form.get(NewTitleOfOutcome).markAsUntouched();
        }
      }
      this.newOutomeSection.setShow(false);
    }
    catch (e) {
      console.log(e);
    }
  }

  public onHeaderActionClick(event) {
    if (event.headerCtrl && event.headerCtrl.id == CancelReport) {
      // To do: Save Modified Prompt
      this.surveySettings = this.viewSetup(null);
      this.ptSvc.logMessage(IceTypes.LOGTYPE.ltUserAlert, this.glRule.activity_description + " cancelled.");
      return;
    }

    if (event.headerCtrl instanceof IcepanelSettings) {
      let surveyPanel: IcepanelSettings = event.headerCtrl;
      let surveyForm: FormGroup = surveyPanel.getForm();
      if (surveyForm == null || false == surveyForm.valid) {
        this.ptSvc.logMessage(IceTypes.LOGTYPE.ltError, "Answer all required questions.");
        return;
      }

      if (this.glRule.obr11_specimen_action_code == "DXOB-OUTCOME") {
        for (let itpl = 0; itpl < this.outcomeDataSource.data.length; itpl++) {
          let thisRec = this.outcomeDataSource.data[itpl];
          if (thisRec == null) {
            this.ptSvc.logMessage(IceTypes.LOGTYPE.ltError, "Error: invalid outcome selection.");
            return;
          }

          let key = thisRec["diagnosis_key"];
          let thisForm: FormGroup = this.outcomeTableSettings.getFormGroupByPrimaryKey(key);
          if (thisForm == null) continue;

          let diagToUpdateAry: diagnosis[] = this.diags.filter(d => d.diagnosis_key == key);
          let dxRefs = this.glRule.DIAGS.filter(dref => dref.diagnosis_key == key);

          let apply = thisRec[ApplyOutcome] ? "ABF" : "";
          if (apply) {
            // search diag refs for diag; if found then set apply otherwise add new mark ref rec status as add also mark form dirty
            if (dxRefs.length > 0) {
              if (dxRefs[0].diagnosis_type_code == "") dxRefs[0].diagnosis_type_code = "ABF";
            }
            else {
              if (diagToUpdateAry.length > 0) {
                this.addDiagRef(diagToUpdateAry[0]);
                thisForm.markAsDirty();
              }
            }
          }
          else {
            // search diag refs for diag; if found then set unapply mark ref rec status as remove also mark form dirty
            if (dxRefs.length > 0) {
              dxRefs[0].diagnosis_type_code = "";
              if (dxRefs[0].offline_record_status == IceTypes.offlineRecStatus.offlineInsert) {
                // remove ref
                for (let idx = 0; idx < this.glRule.DIAGS.length; idx++) {
                  if (this.glRule.DIAGS[idx].diagnosis_key == dxRefs[0].diagnosis_key) {
                    this.glRule.DIAGS.splice(idx, 1);
                    break;
                  }
                }                
              }
              else {
                dxRefs[0].offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
              }
              thisForm.markAsDirty();
            }
          }

          let on = Iceutility.convertToUTCEx(thisRec[OnsetOfOutcome]);
          let re = Iceutility.convertToUTCEx(thisRec[ResolvedOutcome]);
          let stat = thisRec[StatusofOutcome];
          let stats = PatientService.getProblemStatuses().filter(s => stat.toLowerCase() == s.name.toLowerCase());
          if (stats.length > 0)
            stat = stats[0].value;

          if (thisForm.dirty == false) {
            continue;
          }

          // Update diagnosis
          if (diagToUpdateAry != null && diagToUpdateAry.length > 0) {
            diagToUpdateAry[0].onset_of_illness_date = on;
            diagToUpdateAry[0].resolution_date = re;
            diagToUpdateAry[0].status_type = Iceutility.toLong(stat);
            this.ptSvc.insertUpdateDiagnsosis(this.appSvc.getCurrentPatient(), this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), diagToUpdateAry[0]).subscribe(
              data => {
                this.ptSvc.logMessage(IceTypes.LOGTYPE.ltUserAlert, "Successfully updated: " + diagToUpdateAry[0].title);
              },
              error => {
                this.ptSvc.logMessage(IceTypes.LOGTYPE.ltError, "Error: Unable to save outcome diagnosis.");
              });
          }
          else {
            // error
          }
        }
      }

      let totalscore = 0;

      for (let iob = 0; iob < this.glRule.OBSERVS.length; iob++) {
        let ob: observation = this.glRule.OBSERVS[iob];        
        let answer = surveyForm.get(ob.obx4_observation_subid).value;
        if (ob.obx5_observation_value != answer.toString()) {
          ob.observation_date = Iceutility.ConvertToUTC(Iceutility.GetLocalDate(), true);
          this.glRule.activity_date = ob.observation_date;
        }
        ob.obx5_observation_value = answer.toString();
        ob.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

        totalscore += Iceutility.toLong(answer);
      }

      if (totalscore > 0)
        this.glRule.obr25_result_status = totalscore.toString();

      let scoreDesc = "";
      if (this.glRule.obr11_specimen_action_code == "EPDS") {
        scoreDesc = "The patient's ***SCORE*** is: " + this.glRule.obr25_result_status;
        scoreDesc += ".  Where the 'maximum score' is: 30; 'possible depression' is 10 or greater; and always look at item 10 (suicidal thoughts).  ";
        scoreDesc += ".  More details: Mothers who score above 13 are likely to be suffering from a depressive illness of varying severity. The EPDS score should not override clinical judgment.  A careful clinical assessment should be carried out to confirm the diagnosis.  The scale indicates how the mother has felt during the previous week.  In doubtful cases it may be useful to repeat the tool after 2 weeks.  The scale will not detect mothers with anxiety neuroses, phobias or personality disorders.";
      }

      //set these to new pt rule
      if (this.glRule.src_type == IceTypes.SourceType.srcUndefined) {
        this.glRule.management_guideline_key = Iceutility.guid(true);
        this.glRule.trans_account = this.appSvc.getCurrentPatient();
        this.glRule.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;

        // try to get encounter as source
        let fromDt = Iceutility.GetLocalDate();
        Iceutility.addTime(fromDt, -365, 0, 0, 0);
        let toDt = Iceutility.GetLocalDate();

        let dtParams = Iceutility.prepareFromToDates(
          Iceutility.GetDateText(fromDt, null, false),
          Iceutility.GetDateText(toDt, null, false), true);

        // Lookup last encounter then set:
        this.ptSvc.getEncounterList(this.appSvc.getCurrentPatient(), this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), "", <string>dtParams.from, <string>dtParams.to, "").subscribe(
          data => {
            if (Iceutility.isdefined(data) && data.length > 0) {
              let enc = data[data.length - 1];
              if (Iceutility.isdefined(enc)) {
                this.glRule.src_type = IceTypes.SourceType.srcEncounterNotes;
                this.glRule.src_key = enc.encounter_key;
                this.ptSvc.insertUpdateRule(this.appSvc.getCurrentPatient(), this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), this.glRule).subscribe(
                  data => {
                    // To do is error then stay on view
                    // To do: Empty page and notify user of the score
                    this.glTitle = "";
                    this.glDescription = "";
                    this.surveySettings = this.viewSetup(null);
                    this.ptSvc.logMessage(IceTypes.LOGTYPE.ltUserAlert, this.glRule.activity_description + " Successfully saved.");
                    if (scoreDesc.length > 0) this.ptSvc.logMessage(Iceutility.toLong(this.glRule.obr25_result_status) < 13 ? IceTypes.LOGTYPE.ltUserAlert : IceTypes.LOGTYPE.ltMedicalAlert, scoreDesc);
                  },
                  error => {
                    console.log(JSON.stringify(this.ptSvc.getLastErrors()));
                  });
              }
            }
          },
          error => {
            console.log(JSON.stringify(this.ptSvc.getLastErrors()));
          });

      }
      else {
        this.glRule.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
        this.ptSvc.insertUpdateRule(this.appSvc.getCurrentPatient(), this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), this.glRule).subscribe(
          data => {
            // To do is error then stay on view
            // To do: Empty page and notify user of the score
            this.glTitle = "";
            this.glDescription = "";
            this.surveySettings = this.viewSetup(null);
            this.ptSvc.logMessage(IceTypes.LOGTYPE.ltUserAlert, this.glRule.activity_description + " Successfully saved.");
            this.ptSvc.logMessage(Iceutility.toLong(this.glRule.obr25_result_status) < 13 ? IceTypes.LOGTYPE.ltUserAlert : IceTypes.LOGTYPE.ltMedicalAlert, scoreDesc);
          },
          error => {
            console.log(JSON.stringify(this.ptSvc.getLastErrors()));
          });
      }
    }
  }
}
